import { memo } from 'react'

import { UploadPrimitive } from 'modules/documents/upload-primitive'

import type { IUploadInputFileViewProps } from './upload-input-file.types'

import './upload-input-file.styles.scss'

const Component = ({
  id,
  children,
  onChangeInput,
  acceptAttribute,
  isMultiple,
  inputRef,
}: IUploadInputFileViewProps) => (
  <div className="UploadInputFile">
    <UploadPrimitive>{children}</UploadPrimitive>
    <label htmlFor={id} className="UploadInputFile-label" />
    <input
      id={id}
      name={id}
      ref={inputRef}
      type="file"
      className="UploadInputFile-input"
      onChange={onChangeInput}
      accept={acceptAttribute}
      multiple={isMultiple}
      hidden
    />
  </div>
)

export const UploadInputFileView = memo(Component)
